module.exports = __webpack_public_path__ + "static/media/resolucion.25e37848.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/resolucion.svg
// module id = 197
// module chunks = 0